import ArtworkFrame from '../src/ArtworkFrame';
export default ArtworkFrame;
